var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4058_74151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7.33301C6 7.86344 6.21071 8.37215 6.58579 8.74722C6.96086 9.12229 7.46957 9.33301 8 9.33301C8.53043 9.33301 9.03914 9.12229 9.41421 8.74722C9.78929 8.37215 10 7.86344 10 7.33301C10 6.80257 9.78929 6.29387 9.41421 5.91879C9.03914 5.54372 8.53043 5.33301 8 5.33301C7.46957 5.33301 6.96086 5.54372 6.58579 5.91879C6.21071 6.29387 6 6.80257 6 7.33301Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7707 11.1047L8.94202 13.9333C8.69201 14.1831 8.35307 14.3234 7.99968 14.3234C7.6463 14.3234 7.30736 14.1831 7.05735 13.9333L4.22802 11.1047C3.48217 10.3588 2.97424 9.40845 2.76848 8.3739C2.56271 7.33934 2.66834 6.267 3.07202 5.29247C3.4757 4.31795 4.15928 3.48501 5.03634 2.89899C5.9134 2.31297 6.94453 2.00018 7.99935 2.00018C9.05417 2.00018 10.0853 2.31297 10.9624 2.89899C11.8394 3.48501 12.523 4.31795 12.9267 5.29247C13.3304 6.267 13.436 7.33934 13.2302 8.3739C13.0245 9.40845 12.5165 10.3588 11.7707 11.1047Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4058_74151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.38e009c7f86a913457fe2c37de1b1727.svg";
export { ForwardRef as ReactComponent };